import React, { useEffect, useState } from 'react';
import { Category } from "../types";
import { Link } from "react-router-dom";
import { ThemeIcon, Group, Text, Loader, Container } from "@mantine/core";
import { makeGetRequest } from "../services/httpHelper";
import ErrorHandler from "../services/ErrorHandler";
import {
    IconAugmentedReality,
    IconCat,
    IconClipboardHeart,
    IconDeviceTv,
    IconFireHydrant,
    IconHeartHandshake,
    IconLeaf,
  //  IconSearch,
    IconSos,
} from '@tabler/icons-react';
import { isErrorObject, toTitleCase } from "../utils/utils";

const CategoriesPage = () => {
    const [categories, setCategories] = useState<Category[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);


       const iconMapping: { [key: string]: any } = {
            Medical: IconClipboardHeart,
            Environment: IconLeaf,
            Nonprofit: IconHeartHandshake,
            Animals: IconCat,
            Crisis: IconFireHydrant,
            Technology: IconAugmentedReality,
            Films: IconDeviceTv,
        };

    useEffect(() => {
        const getCampaignCategory = async () => {
            setIsLoading(true);
            const res = await makeGetRequest('campaign-categories');
            if (isErrorObject(res)) {
                setIsLoading(false);
                const errorMessage = ErrorHandler(res);
                setError(errorMessage);
            } else {
                setCategories(res.data);
                setIsLoading(false);
                setError(null);
            }
        };

        getCampaignCategory();
    }, []);

    if (isLoading) return <Loader />;
    if (error) return <Text color="red">{error}</Text>;

    return (
        <Container>
            <Text size="xl" fw={700} mb="lg">
                Browse Categories
            </Text>
            {categories.map((category) => (
                <Link to={`/campaigns/category/${category.id}`} key={category.id}>
                    <Group noWrap align="center" mb="md">
                        <ThemeIcon size={34} variant="default" radius="md">
                            {iconMapping[category.category.trim()] ? (
                                React.createElement(iconMapping[category.category.trim()], {
                                    size: 22,
                                    stroke: 1.5,
                                })
                            ) : (
                                <IconSos size={22} stroke={1.5} />
                            )}
                        </ThemeIcon>
                        <Text size="sm" fw={500}>
                            {toTitleCase(category.category.trim())}
                        </Text>
                    </Group>
                </Link>
            ))}
        </Container>
    );
};

export default CategoriesPage;
